import { ChangeDetectorRef, Component, Input, AfterViewChecked } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbItem } from '@scalefast/core';

@Component({
  selector: 'app-breadcrumb-template',
  styleUrls: ['./breadcrumb-template.component.scss'],
  templateUrl: './breadcrumb-template.component.html',
  standalone: true,
  imports: [RouterLink],
})
export class AppBreadcrumbTemplateComponent implements AfterViewChecked {
  @Input() breadcrumbItems: BreadcrumbItem[] | null = [];
  @Input() showHome = true;

  redirectsMapping: BreadcrumbItem[] = [
    { label: 'preguntas', path: '/faq' },
    { label: 'faq', path: '/faq' },
  ];

  constructor(private cdr: ChangeDetectorRef) {}

  get hasItems(): boolean {
    if (!this.breadcrumbItems) {
      return false;
    }
    return this.breadcrumbItems?.length > 0;
  }

  get shouldHideHomeBreadcrumb(): boolean {
    if (!this.breadcrumbItems) {
      return false;
    }

    if (!this.showHome) {
      return false;
    }

    if (this.breadcrumbItems.length === 0) {
      return false;
    }

    return this.breadcrumbItems[0].path === '/home';
  }

  trackByItems(index: number, item: BreadcrumbItem): string {
    return item.path;
  }

  ngAfterViewChecked(): void {
    this.updateBreadcrumbPaths();
  }

  private updateBreadcrumbPaths(): void {
    if (this.breadcrumbItems && this.breadcrumbItems.length > 0) {
      this.breadcrumbItems.forEach((item: BreadcrumbItem) => {
        const redirectItem = this.redirectsMapping.find((redirect) => redirect.label === item.label);

        if (redirectItem) {
          item.path = redirectItem.path;
        }
      });

      this.cdr.detectChanges();
    }
  }
}
